import React, { FC } from "react";
import { Button, Container, Icon, Notification, Skeleton } from "@telia/teddy";
import { useParams } from "react-router";
import { goBackToOrdersOverview } from "../../../utils";
import ContractSection from "./ContractSection";
import OrderSummarySection from "./OrderSummarySection";
import "./OrderDetail.less";
import CustomerSection from "./CustomerSection";
import OrderContentsSection from "./OrderContentsSection";
import PayerSection from "./PayerSection";
import { useOrderDetailsQuery } from "./useOrderDetailsQuery";
import OrderDetailSection from "./OrderDetailSection";

const OrderDetail: FC = () => {
    const { orderId = "" } = useParams();
    const { data: order, isLoading, error } = useOrderDetailsQuery(orderId);

    return (
        <div className="order-detail">
            <Container>
                <Button variant="secondary" size="sm" onClick={goBackToOrdersOverview} className="orders__back-button">
                    <Icon name="arrow-left" size="sm" aria-hidden="true" focusable="false" />
                    Tilbake
                </Button>
                {isLoading && (
                    <div className="order-detail__layout">
                        <div className="order-detail__section">
                            <Skeleton height="32px" width="240px" mb="200" />
                            <Skeleton height="190px" width="100%" />
                        </div>
                        <div className="order-detail__section">
                            <Skeleton height="24px" width="140px" mb="200" />
                            <Skeleton height="230px" width="100%" />
                        </div>
                        <div className="order-detail__section">
                            <Skeleton height="24px" width="170px" mb="200" />
                            <Skeleton height="220px" width="100%" />
                        </div>
                        <div className="order-detail__section">
                            <Skeleton height="70px" width="100%" />
                        </div>
                    </div>
                )}
                {error && !isLoading && (
                    <Notification type="tile" variant="error" mb="200">
                        <Notification.Icon />
                        <Notification.Text>
                            {error instanceof Error ? error.message : "Kunne ikke hente ordredetaljer."}
                        </Notification.Text>
                    </Notification>
                )}
                {order && (
                    <div className="order-detail__layout">
                        <OrderSummarySection order={order} />
                        <CustomerSection order={order} />
                        <PayerSection order={order} />
                        <OrderContentsSection order={order} />
                        <OrderDetailSection>
                            <ContractSection orderId={order.orderId} />
                        </OrderDetailSection>
                    </div>
                )}
            </Container>
        </div>
    );
};

export default OrderDetail;
